import React, { useEffect, useCallback, useRef, useState } from "react";
import { Button, Typography, notification, Steps, Modal, Checkbox } from "antd";
import "../Induction/Induction.css";
import { useNavigate } from "react-router-dom";
import UserApi from "../common/Apis/UserApi";
import { CheckCircleFilled } from "@ant-design/icons";
import FooterRegistraion from "../common/FooterDashboard/FooterRegistraion";
const { Title } = Typography;
const Induction = (props) => {
  const { placement } = "topRight";
  const [api, contextHolder] = notification.useNotification();
  let navigate = useNavigate();

  // Get User Token and Email
  const token = localStorage.getItem("userToken");
  const userEmail = localStorage.getItem("userEmail");

  // Disabled MCQ button video end
  const [disableMCQ, setDisableMCQ] = useState(true);

  const Remember_Notice = localStorage.getItem("RememberNotice");
  let Notice = Remember_Notice === null ? true : false;
  const [isModalOpen, setIsModalOpen] = useState(Notice);
  const [RemeberNotice, Set_RemeberNotice] = useState(null);

  // User Click Ok, I understood button store session
  const handleOk = () => {
    setIsModalOpen(false);
    if (RemeberNotice === true) {
      localStorage.setItem("RememberNotice", true);
    }
  };

  // Update Aptitude Test Status Function

  const updateAptitudeTestStatus = useCallback(async () => {
    const formData = new FormData();
    formData.append("email", userEmail);
    formData.append(`aptitudeTestStatus`, "INDUCTION_VIDEO");

    UserApi.updateAptitudeTestStatus(formData)
      .then((response) => {})
      .catch((err) => {
        // Error Notification
        if (err) {
          api.error({
            message: `${err}`,
            placement,
          });
        }
      });
  }, [api, userEmail]);
  const tokenVerification = useCallback(() => {
    UserApi.tokenVerification(token)
      .then((response) => {
        updateAptitudeTestStatus();
      })
      .catch((err) => {
        if (err.success === false) {
          return navigate("/");
        }
      });
  }, [updateAptitudeTestStatus, token, navigate]);

  useEffect(() => {
    tokenVerification();
    // Page onLoad Scroll Top
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [tokenVerification]);
  const iframeRef = useRef(null);

  // Convert Time To Float Function
  const convertTimeToFloat = (timeString) => {
    const [hours, minutes] = timeString.split(":");
    const floatTime = parseInt(hours, 10) * 60 + parseInt(minutes, 10);
    return floatTime;
  };

  useEffect(() => {
    const iframeWindow = iframeRef.current.contentWindow;
    const handleIframeMessage = (event) => {
      if (event.origin !== window.location.origin) {
        return;
      }

      // Get the Video Duration
      if (event.data.type === "variableValue") {
        const myVariable = event.data.value;
        if (myVariable) {
          const formattedTime = convertTimeToFloat(myVariable);
          if (formattedTime > 70) {
            setDisableMCQ(false);
          }
        }
      }
    };

    window.addEventListener("message", handleIframeMessage);

    const timer = setInterval(() => {
      iframeWindow.postMessage({ type: "getVariableValue" }, "*");
    }, 1000);

    return () => {
      window.removeEventListener("message", handleIframeMessage);
      clearInterval(timer);
    };
  }, []);

  // Registration  Steps
  const items = [
    {
      description: (
        <>
          <div className="stepsLayout">
            <p className="step">Step 1</p>
            <h4>
              <b>Induction</b>
            </h4>
            <p className="process">In Progress</p>
          </div>
        </>
      ),
      status: "process",
    },
    {
      description: (
        <>
          <div className="stepsLayout">
            <p className="step">Step 2</p>
            <h4>
              <b>MCQ Test</b>
            </h4>
            <p>Pending</p>
          </div>
        </>
      ),
      status: "wait",
    },
    {
      description: (
        <>
          <div className="stepsLayout">
            <p className="step">Step 3</p>
            <h4>
              <b>Protective Clothing</b>
            </h4>
            <p>Pending</p>
          </div>
        </>
      ),
      status: "wait",
    },
    {
      description: (
        <>
          <div className="stepsLayout">
            <p className="step">Step 4</p>
            <h4>
              <b>Health Questionnaire</b>
            </h4>
            <p>Pending</p>
          </div>
        </>
      ),
      status: "wait",
    },
    {
      description: (
        <>
          <div className="stepsLayout">
            <p className="step">Step 5</p>
            <h4>
              <b>Registraion</b>
            </h4>
            <p>Pending</p>
          </div>
        </>
      ),
      status: "wait",
    },
  ];

  const customDot = (dot, { status }) => {
    switch (status) {
      case "finish":
        return <CheckCircleFilled />;
      case "process":
        return (
          <>
            <div className="circle-step">
              <div id="outer-circle">
                <div id="inner-circle"></div>
              </div>
            </div>
          </>
        );
      case "wait":
        return (
          <>
            <div className="circle-step">
              <div id="outer-circle">
                <div id="inner-circle"></div>
              </div>
            </div>
          </>
        );
      default:
        return dot;
    }
  };
  return (
    <>
      <Modal
        open={isModalOpen}
        closable={false}
        width={800}
        footer={[
          <div className="checkbtnModel">
            <Checkbox
              className="healthQuestion"
              onChange={() => Set_RemeberNotice(true)}
            >
              Don't display again
            </Checkbox>
          </div>,
          <Button key="submit" type="primary" onClick={handleOk}>
            Ok, I understood
          </Button>,
        ]}
      >
        <p>
          <b>MCQ-Based Aptitude Test Requirement</b>
        </p>
        <p>
          To complete your registration on the iVA-Connect Platform, please
          carefully read and follow the instructions below. It is important to
          note that the following steps are mandatory for all users:
        </p>
        <p>
          <b>Watch the Induction Video:</b>
        </p>
        <p>
          Before taking the MCQ-based aptitude test, you are required to watch
          the Induction Video. The video provides essential information about
          the platform, its features, and guidelines for using it effectively.
          <br />
          Take your time to understand the content thoroughly.
        </p>
        <p>
          <b>MCQ-Based Aptitude Test:</b>
        </p>
        <p>
          Following the Induction Video, you will proceed to the MCQ-based
          aptitude test. The test consists of multiple-choice questions designed
          to assess your aptitude and suitability for the iVA-Connect Platform.
          All questions in the test are compulsory, and it is important to
          answer them to the best of your abilities.
        </p>
        <p>
          <b>Passing the Test:</b>
        </p>
        <p>
          In order to proceed to the next step, it is mandatory to achieve a
          passing score on the MCQ-based aptitude test.
          <br /> A passing score indicates your understanding and competence in
          the required areas. Make sure to answer all questions accurately and
          demonstrate your knowledge effectively. Please note that completion of
          the above steps is necessary to successfully register on the
          iVA-Connect Platform. We encourage you to take your time, carefully
          watch the Induction Video, and give your best effort in the MCQ-based
          aptitude test.
        </p>
        <p>
          Should you have any questions or concerns regarding the process, feel
          free to reach out to our support team for assistance.
        </p>
        <p>Thank you for your cooperation.</p>
        <p>
          Best regards,
          <br /> IVA-Connect
        </p>
      </Modal>
      <div
        className="logo-title"
        style={{ boxShadow: "3px 3px 10px -4px rgba(0, 0, 0, 0.1)" }}
      >
        <img
          src="/assest/Images/Logo/logo.png"
          className="logo-png"
          style={{ width: "14%" }}
        />
      </div>
      <div className="container form-container pt-3">
        {contextHolder}
        <div className="row justify-content-center ">
          <div className="col-xl-10 col-lg-10 col-md-12 px-0">
            <Steps current={1} progressDot={customDot}>
              {items.map((item) => (
                <Steps.Step
                  key={item.title}
                  title={item.title}
                  description={item.description}
                  status={item.status}
                />
              ))}
            </Steps>
          </div>
          <div className="col-xl-7 col-lg-7 col-md-9 px-0 pt-5 asdsad">
            <Title className="content-title">Induction</Title>
            <iframe
              src={`/videoplayer.html`}
              ref={iframeRef}
              title="Video Player"
              className="video-frame"
            />

            <div className="d-flex justify-content-center">
              <Button
                type="Link"
                href={"/test"}
                className="btn btn-primary w-50 mcq-button btn-href"
                // disabled={disableMCQ}
              >
                MCQ Test
              </Button>
            </div>
            <p className="content Register-content pb-5">
              Mandatory Test. All questions are compulsory.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Induction;


